import { create } from 'zustand';

interface MoveState {
  isSequenceMoving: boolean;
  startSequenceMove: (chapterSequenceId: string | number) => void;
  stopSequenceMove: () => void;
  chapterSequenceId: string | number | null;
  isChapterMoving: boolean;
  startChapterMove: (chapterId: string | number) => void;
  stopChapterMove: () => void;
  chapterId: string | number | null;
}

export const useMoveStore = create<MoveState>(set => ({
  isSequenceMoving: false,
  chapterSequenceId: null,
  chapterId: null,
  startSequenceMove: (chapterSequenceId: string | number) =>
    set({ isSequenceMoving: true, chapterSequenceId }),
  stopSequenceMove: () =>
    set({ isSequenceMoving: false, chapterSequenceId: null }),
  isChapterMoving: false,
  startChapterMove: (chapterId: string | number) =>
    set({ isChapterMoving: true, chapterId }),
  stopChapterMove: () => set({ isChapterMoving: false, chapterId: null })
}));
